import React from "react";
import {useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ProtectedRoute } from "./Apis/endpoints";
import Intro1 from "./Introduction/Intro1";
import Intro2 from "./Introduction/Intro2";
import Intro3 from "./Introduction/Intro3";
import Intro4 from "./Introduction/Intro4";
import BaseLayout from "./Main/base";
import Login from "./Security/Login"
import Signup from "./Security/SignUp";
import VideoRecording from "./Video-Upload-Section/video-upload2";
import Result_feed from "./Main/Result/Result_feed";
import MyResult from "./Main/Result/Myresult";
import UploadPage from "./Video-Upload-Section/Video-upload1";
import Completedpop from "./Video-Upload-Section/completed-popup";
import Result from "./Main/Result/result";
import Setpassword from "./Security/ResetPassword"
// import ResetPasswordPage from "./Security/ResetPassword";
import AudioGraph from "./Main/Right-Section/LineChartComponent";
import LandingPage from "./Main/landing-page/Landing-page";
import Signuppopup from "./Security/signuppopup";
import setupInactivityTracker from "./Apis/setupInactivityTracker";
import Googledata from "./Security/googledata";

function App() {
  useEffect(() => {
    // Start tracking user inactivity
    setupInactivityTracker();
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/reset-password/:token" element={<Setpassword />}/>
        <Route path="/signuppopup" element={<Signuppopup/>}/>
        <Route path="/intro1" element={<Intro1 />} />
        <Route path="/intro2" element={<Intro2 />} />
        <Route path="/intro3" element={<Intro3 />} />
        <Route path="/intro4" element={<Intro4 />} />
        <Route path="/" element={<LandingPage/>}/>
        <Route element={<ProtectedRoute />}>
          <Route path="/video/:mode?" element={<BaseLayout><VideoRecording /></BaseLayout>} />
          <Route path="/myresult" element={<BaseLayout><MyResult><Result_feed /></MyResult></BaseLayout>} />
          <Route path="/upload" element={<BaseLayout><UploadPage /></BaseLayout>} />
          <Route path="/completedpopup" element={<Completedpop />} />
          <Route path="/result/:videoId/:mode" element={<BaseLayout><Result /></BaseLayout>} />
          <Route path="/audio-graph" element={<AudioGraph />} />
        </Route>
          <Route path='/auth/google/callback' element={<Googledata/>}/>
      </Routes>
    </BrowserRouter>
  );
}

export default App;